module.exports = __webpack_public_path__ + "static/img/13.f26a8aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/eng/13.png
// module id = DQg6
// module chunks = 0